import { render, staticRenderFns } from "./MarketViewDetail.vue?vue&type=template&id=99c24a7a"
import script from "./MarketViewDetail.vue?vue&type=script&lang=js"
export * from "./MarketViewDetail.vue?vue&type=script&lang=js"
import style0 from "./MarketViewDetail.vue?vue&type=style&index=0&id=99c24a7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports